import { StatusCadastro } from '../shared/enums/status-cadastro.enum';

export class UnidadeCadastro {
    public status: StatusCadastro;
    constructor(
        public codigo: string,
        public nome: string,
        public limite: number
    ) {}
}
